import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../../../assets/logo.png';
import './RegulatorikHeader.css';

const RegulatorikHeader = () => {
    return (
        <div className="regulatorik-header">
            <div className="header-top">
                <div className="breadcrumb">
                    <Link to="/dashboard" className="breadcrumb-link">Dashboard</Link>
                    <span className="breadcrumb-separator">›</span>
                    <span className="breadcrumb-current">Regulatorik</span>
                </div>
                <img src={logo} alt="Logo" className="header-logo" />
            </div>
            <h1>Regulatorik - Neuigkeiten, Umsetzung und Archiv</h1>
            <p className="header-subtitle">Aktuelle Entwicklungen und historische Dokumente</p>
        </div>
    );
};

export default RegulatorikHeader;